var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-overlay',{attrs:{"show":_vm.visible},on:{"click":function($event){_vm.visible = false}}},[_c('div',{attrs:{"id":"to-share"}},[_c('van-image',{attrs:{"src":"https://public.qiniu.xcims.com/wx_toshare.png"}}),_c('div')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }